(function () {
  if (window.__shiftNativeVideoAutoplay) return;
  window.__shiftNativeVideoAutoplay = true;

  var selector = 'video.shift-native-video[data-shift-autoplay-video]';
  var states = new WeakMap();
  var activeStates = [];
  var frameRequested = false;

  function tryPlay(video) {
    video.muted = true;
    video.defaultMuted = true;
    video.controls = false;
    video.loop = true;
    if (video.ended) video.currentTime = 0;
    var result = video.play();
    if (result && typeof result.catch === 'function') result.catch(function () {});
  }

  function sync(state) {
    if (state.visible || state.hovered) {
      tryPlay(state.video);
    } else {
      state.video.pause();
    }
  }

  function isVisibleInViewport(video) {
    var rect = video.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    var visibleHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
    var visibleWidth = Math.min(rect.right, viewportWidth) - Math.max(rect.left, 0);
    return visibleHeight >= Math.min(80, rect.height * 0.2) &&
      visibleWidth >= Math.min(80, rect.width * 0.2);
  }

  function refreshVisibility() {
    frameRequested = false;
    activeStates.forEach(function (state) {
      state.visible = isVisibleInViewport(state.video);
      sync(state);
    });
  }

  function scheduleVisibilityRefresh() {
    if (frameRequested) return;
    frameRequested = true;
    window.requestAnimationFrame(refreshVisibility);
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var state = states.get(entry.target);
      if (!state) return;
      state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.1;
      sync(state);
    });
  }, { threshold: [0, 0.1, 0.5] });

  function setup(video) {
    if (states.has(video)) return;

    video.muted = true;
    video.defaultMuted = true;
    video.controls = false;
    video.loop = true;
    video.playsInline = true;

    var state = { video: video, visible: false, hovered: false };
    states.set(video, state);
    activeStates.push(state);

    video.addEventListener('mouseenter', function () {
      state.hovered = true;
      sync(state);
    });

    video.addEventListener('mouseleave', function () {
      state.hovered = false;
      sync(state);
    });

    video.addEventListener('ended', function () {
      if (state.visible || state.hovered) {
        video.currentTime = 0;
        tryPlay(video);
      }
    });

    video.addEventListener('loadedmetadata', function () {
      scheduleVisibilityRefresh();
    });

    observer.observe(video);
  }

  function init(root) {
    if (root.nodeType === 1 && root.matches && root.matches(selector)) setup(root);
    if (root.querySelectorAll) root.querySelectorAll(selector).forEach(setup);
    scheduleVisibilityRefresh();
  }

  function start() {
    init(document);

    window.addEventListener('scroll', scheduleVisibilityRefresh, { passive: true });
    window.addEventListener('resize', scheduleVisibilityRefresh);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(init);
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
